module.exports = __webpack_public_path__ + "site/img/shipinhao.2a0eb95.png";


//////////////////
// WEBPACK FOOTER
// ./site/shipinhao.png
// module id = 124
// module chunks = 1